<div *ngIf="isVisible" class="modal-overlay">
  <div class="modal-content" (click)="onModalContentClick($event); $event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">{{ modalTitle }}</h2>
        <button class="close-button" (click)="onClose()" [disabled]="isSubmitting">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
      <div class="header-separator"></div>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Profile Photo Section (employees only) -->
      <div class="profile-photo-section" *ngIf="showEmployeeOpsFields">
        <h3 class="section-title">Profile Photo</h3>
        <div class="photo-upload-wrapper">
          <div class="photo-upload-area">
            <div class="photo-preview" [class.has-photo]="profilePhotoPreview">
              <!-- Loading State -->
              <div *ngIf="isUploadingPhoto" class="photo-loading">
                <div class="loading-spinner"></div>
              </div>

              <!-- Placeholder when no photo -->
              <div *ngIf="!profilePhotoPreview && !isUploadingPhoto" class="photo-placeholder">
                <!-- Show default user icon -->
                <img
                  src="assets/images/employee-icons/user.svg"
                  alt="Default Profile"
                  class="default-icon"
                />
              </div>

              <!-- Photo Preview -->
              <img
                *ngIf="profilePhotoPreview && !isUploadingPhoto"
                [src]="profilePhotoPreview"
                alt="Profile Photo"
                class="photo-image"
              />
            </div>

            <label for="photo-upload" class="upload-link" [class.disabled]="isUploadingPhoto">
              {{ profilePhotoPreview ? 'Edit photo' : 'Upload a photo' }}
            </label>

            <input
              type="file"
              id="photo-upload"
              accept="image/png, image/jpeg, image/jpg, image/gif"
              (change)="onFileSelected($event)"
              class="file-input"
              [disabled]="isUploadingPhoto"
            />
          </div>

          <!-- Upload Error Message -->
          <div *ngIf="uploadError" class="upload-error">
            {{ uploadError }}
          </div>
        </div>
      </div>

      <!-- Form Fields -->
      <form [formGroup]="employeeForm" class="employee-form">
        <!-- Personal Information -->
        <div class="form-section">
          <div class="form-row">
            <div class="form-field">
              <label for="first_name" class="field-label"
                >First Name <span class="required">*</span></label
              >
              <div class="input-container">
                <input
                  type="text"
                  id="first_name"
                  formControlName="first_name"
                  placeholder="e.g. John"
                  class="form-input"
                  maxlength="100"
                  [class.error]="getFieldError('first_name')"
                  [disabled]="isSubmitting"
                />
              </div>
              <div class="error-message" *ngIf="getFieldError('first_name')">
                {{ getFieldError('first_name') }}
              </div>
            </div>
            <div class="form-field">
              <label for="last_name" class="field-label"
                >Last Name <span class="required">*</span></label
              >
              <div class="input-container">
                <input
                  type="text"
                  id="last_name"
                  formControlName="last_name"
                  placeholder="e.g. Doe"
                  class="form-input"
                  maxlength="100"
                  [class.error]="getFieldError('last_name')"
                  [disabled]="isSubmitting"
                />
              </div>
              <div class="error-message" *ngIf="getFieldError('last_name')">
                {{ getFieldError('last_name') }}
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-field">
              <label for="email" class="field-label">Email <span class="required">*</span></label>
              <div class="input-container">
                <input
                  type="email"
                  id="email"
                  formControlName="email"
                  placeholder="e.g. johndoe@example.com"
                  class="form-input"
                  [class.error]="getFieldError('email')"
                  [disabled]="isSubmitting"
                />
              </div>
              <div class="error-message" *ngIf="getFieldError('email')">
                {{ getFieldError('email') }}
              </div>
            </div>
            <div class="form-field">
              <label for="phone_number" class="field-label"
                >Phone Number <span class="required">*</span></label
              >
              <div class="input-container">
                <input
                  type="tel"
                  inputmode="tel"
                  autocomplete="tel"
                  id="phone_number"
                  formControlName="phone_number"
                  placeholder="e.g. (123) 456 7890"
                  class="form-input"
                  [attr.maxlength]="phoneMaxLength"
                  [class.error]="getFieldError('phone_number')"
                  [disabled]="isSubmitting"
                  (input)="onPhoneInput($event)"
                  (keyup)="onPhoneKeyup()"
                />
              </div>
              <div class="error-message" *ngIf="getFieldError('phone_number')">
                {{ getFieldError('phone_number') }}
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="showEmployeeOpsFields">
            <div class="form-field">
              <label for="employeeId" class="field-label">Employee ID</label>
              <div class="input-container">
                <input
                  type="text"
                  id="employeeId"
                  formControlName="employeeId"
                  placeholder="EMP#143"
                  class="form-input readonly"
                  readonly
                  [disabled]="true"
                />
              </div>
            </div>
            <div class="form-field">
              <label for="designation" class="field-label"
                >Role/Designation <span class="required">*</span></label
              >
              <div class="input-container">
                <input
                  type="text"
                  id="designation"
                  formControlName="designation"
                  placeholder="e.g. Detailing Specialist"
                  class="form-input"
                  [class.error]="getFieldError('designation')"
                  [disabled]="isSubmitting"
                  (input)="onDesignationInput($event)"
                  (keydown)="onDesignationKeydown($event)"
                />
              </div>
              <div class="error-message" *ngIf="getFieldError('designation')">
                {{ getFieldError('designation') }}
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-field">
              <label for="role" class="field-label"
                >Permission <span class="required">*</span></label
              >
              <div class="input-container">
                <mat-select
                  class="form-select"
                  formControlName="role"
                  placeholder="Select permission"
                  [disabled]="isSubmitting || isEditMode"
                  [class.error]="getFieldError('role')"
                >
                  <mat-option
                    *ngFor="let permission of permissionOptions"
                    [value]="permission.value"
                    >{{ permission.label }}</mat-option
                  >
                </mat-select>
              </div>
              <div class="error-message" *ngIf="getFieldError('role')">
                {{ getFieldError('role') }}
              </div>
            </div>
            <div class="form-field" *ngIf="showEmployeeOpsFields">
              <label for="location_id" class="field-label"
                >Location <span class="required">*</span></label
              >
              <div class="input-container">
                <mat-select
                  class="form-select"
                  formControlName="location_id"
                  placeholder="Select a location"
                  [disabled]="isLoadingLocations || isSubmitting"
                  [class.error]="getFieldError('location_id')"
                >
                  <mat-option
                    *ngIf="isLoadingLocations"
                    [disabled]="true"
                    class="loading-locations"
                  >
                    Loading locations...
                  </mat-option>
                  <mat-option *ngFor="let location of locations" [value]="location.value">
                    {{ location.label }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="error-message" *ngIf="getFieldError('location_id')">
                {{ getFieldError('location_id') }}
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="showEmployeeOpsFields || showStatusField">
            <div class="form-field" *ngIf="showEmployeeOpsFields">
              <label for="start_date" class="field-label"
                >Start Date <span class="required">*</span></label
              >
              <div class="input-container date-input-container">
                <app-custom-date-picker
                  formControlName="start_date"
                  placeholder="Select date"
                  [showTime]="false"
                  [showFooterButtons]="false"
                  [locationDetails]="startDateLocationDetails"
                  [allowPastDates]="false"
                  [disabled]="isSubmitting"
                  [class.error]="getFieldError('start_date')"
                >
                </app-custom-date-picker>
              </div>
              <div class="error-message" *ngIf="getFieldError('start_date')">
                {{ getFieldError('start_date') }}
              </div>
            </div>
            <div class="form-field" *ngIf="showStatusField">
              <label for="status" class="field-label">Status <span class="required">*</span></label>
              <div class="input-container">
                <mat-select
                  class="form-select"
                  formControlName="status"
                  placeholder="Select a status"
                  [disabled]="isSubmitting"
                  [class.error]="getFieldError('status')"
                >
                  <mat-option *ngFor="let statuse of statuses" [value]="statuse.value">{{
                    statuse.label
                  }}</mat-option>
                </mat-select>
              </div>
              <div class="error-message" *ngIf="getFieldError('status')">
                {{ getFieldError('status') }}
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="showOpeningBalanceField">
            <div class="form-field">
              <label for="opening_balance" class="field-label"
                >Opening balance <span class="required">*</span></label
              >
              <div class="input-container">
                <app-currency-action-input
                  formControlName="default_opening_balance"
                  [showAction]="false"
                  [allowNull]="true"
                  [useNumberInput]="true"
                  [class.error]="getFieldError('default_opening_balance')"
                  [minInput]="'1'"
                >
                </app-currency-action-input>
              </div>
              <div class="error-message" *ngIf="getFieldError('default_opening_balance')">
                {{ getFieldError('default_opening_balance') }}
              </div>
            </div>
            <div class="form-field">
              <!-- spacer to keep opening balance half-width -->
            </div>
          </div>
        </div>

        <!-- Set Login Credentials -->
        <div class="form-section">
          <h3 class="section-title">Set Login Credentials</h3>
          <div class="form-row">
            <div class="form-field" *ngIf="showUsernameField">
              <label for="username" class="field-label"
                >User Name <span class="required">*</span></label
              >
              <div class="input-container">
                <input
                  type="email"
                  id="username"
                  formControlName="username"
                  placeholder="e.g. johndoe@example.com"
                  class="form-input"
                  autocomplete="off"
                  [class.error]="getFieldError('username')"
                  [disabled]="isSubmitting"
                />
              </div>
              <div class="error-message" *ngIf="getFieldError('username')">
                {{ getFieldError('username') }}
              </div>
            </div>
            <div class="form-field" [class.full-width]="!showUsernameField">
              <label for="password" class="field-label"
                >Password <span class="required" *ngIf="!isEditMode">*</span></label
              >
              <div class="input-container">
                <input
                  type="password"
                  id="password"
                  formControlName="password"
                  class="form-input"
                  autocomplete="new-password"
                  [class.error]="getFieldError('password')"
                  [disabled]="isSubmitting"
                />
              </div>
              <div class="error-message" *ngIf="getFieldError('password')">
                {{ getFieldError('password') }}
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="showEmployeeOpsFields">
            <div class="form-field full-width">
              <label for="link" class="field-label">Invite Link</label>
              <div class="input-container">
                <input
                  type="text"
                  id="link"
                  formControlName="link"
                  class="form-input"
                  readonly
                  [disabled]="isSubmitting"
                />
                <button
                  type="button"
                  class="copy-link-btn"
                  (click)="copyInviteLink()"
                  [disabled]="isSubmitting"
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="9"
                      y="9"
                      width="13"
                      height="13"
                      rx="2"
                      ry="2"
                      stroke="currentColor"
                      stroke-width="2"
                    />
                    <path
                      d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                      stroke="currentColor"
                      stroke-width="2"
                    />
                  </svg>
                  Copy link
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <div class="footer-buttons">
        <div class="action-buttons">
          <button
            type="button"
            class="btn btn-tertiary"
            (click)="onClose()"
            [disabled]="isSubmitting"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary btn-medium"
            [class.disabled]="isUpdateButtonDisabled"
            [disabled]="isUpdateButtonDisabled"
            (click)="onSave()"
          >
            <span *ngIf="!isSubmitting">{{ isEditMode ? 'Update' : 'Save' }}</span>
            <span *ngIf="isSubmitting" class="loading-content">
              <svg
                class="spinner"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-dasharray="31.416"
                  stroke-dashoffset="31.416"
                >
                  <animate
                    attributeName="stroke-dasharray"
                    dur="2s"
                    values="0 31.416;15.708 15.708;0 31.416"
                    repeatCount="indefinite"
                  />
                  <animate
                    attributeName="stroke-dashoffset"
                    dur="2s"
                    values="0;-15.708;-31.416"
                    repeatCount="indefinite"
                  />
                </circle>
              </svg>
              Saving...
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Success Modal - Outside main modal to avoid z-index issues -->
<app-success-modal
  [isVisible]="showSuccessModal"
  [data]="successModalData"
  (close)="onSuccessModalClose()"
>
</app-success-modal>

<!-- Close Confirmation Alert Modal -->
<app-alert-modal
  [isOpen]="showCloseConfirmationModal"
  title="Discard Changes?"
  description="You have unsaved changes. Closing the modal will lose all entered information."
  primaryButtonText="Discard"
  secondaryButtonText="Cancel"
  [primaryButtonClass]="'btn-danger'"
  [secondaryButtonClass]="'btn-secondary'"
  (close)="onCloseConfirmationCancel()"
  (primaryAction)="onCloseConfirmationConfirm()"
  (secondaryAction)="onCloseConfirmationCancel()"
>
</app-alert-modal>
